export const MIN_VIDEO_DURATION_IN_MIN = 1
export const MAX_VIDEO_DURATION_IN_MIN = 7
export const MAX_VIDEO_FILE_SIZE_IN_MB = 2000
export const POSTER_SIZES: [number, number][] = [[720, 400]]
export const MAX_FILE_SIZE_MB = 10
export const REFETCH_INTERVALL = 10000 // 10 sec.
